import React from "react";
import {
  createMuiTheme,
  ThemeProvider,
  CssBaseline,
  AppBar,
  Toolbar,
  Typography,
  Card,
  Container,
  makeStyles,
} from "@material-ui/core";
import { Helmet } from "react-helmet";
import Skeleton from "@material-ui/lab/Skeleton";
import { pink, deepPurple } from "@material-ui/core/colors";

const theme = createMuiTheme({
  palette: {
    type: "dark",
    primary: pink,
    secondary: deepPurple,
  },
});

const useStyles = makeStyles(theme => ({
  quizTitle: {
    marginTop: theme.spacing(4),
  },
  quizDate: {
    marginBottom: theme.spacing(4),
  },
  skeletonCard: {
    padding: "16px",
    marginBottom: "16px",
  },
}));

const FourZeroFour = () => {
  const classes = useStyles();
  return (
    <ThemeProvider theme={theme}>
      <Helmet defer={false}>
        <title>Rich's Riddler</title>
      </Helmet>
      <CssBaseline />
      <AppBar position="sticky">
        <Toolbar variant="dense">
          <Typography variant="h5">Rich's Riddler</Typography>
        </Toolbar>
      </AppBar>
      <Container maxWidth="sm">
        <Skeleton variant="rect" height={100} className={classes.quizTitle} />
        <Skeleton
          variant="text"
          width={"35%"}
          height={50}
          className={classes.quizDate}
        />
        <Card className={classes.skeletonCard}>
          <Skeleton variant="text" width={"40%"} height={50} />
          <Skeleton variant="rect" height={200} />
          <Skeleton variant="text" height={50} />
          <Skeleton variant="rect" height={75} />
        </Card>
        <Card className={classes.skeletonCard}>
          <Skeleton variant="text" width={"40%"} height={50} />
          <Skeleton variant="text" height={50} />
          <Skeleton variant="rect" height={75} />
        </Card>
      </Container>
    </ThemeProvider>
  );
};

export default FourZeroFour;
